import { TimelineItemController } from '../controller/TimelineItemController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class TimelineItemWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TimelineItemController,
    });
  }

  get alertTitle(): string {
    return this.getAttribute('data-alert-title') || '';
  }

  set alertTitle(alertTitle: string) {
    this.setAttribute('data-alert-title', alertTitle);
  }

  get killChainPhases(): number {
    const killChainPhases = this.getAttribute('data-kill-chain-phases');
    return killChainPhases ? parseInt(killChainPhases, 10) : 0;
  }

  set killChainPhases(killChainPhases: number | null) {
    if (typeof killChainPhases === 'number') {
      this.setAttribute('data-kill-chain-phases', String(killChainPhases));
    }
  }

  get severity(): number {
    const severity = this.getAttribute('data-severity');
    return severity ? parseInt(severity, 10) : 1;
  }

  set severity(severity: number) {
    this.setAttribute('data-severity', String(severity));
  }

  get alertDescription(): string {
    return this.getAttribute('data-alert-description') || '';
  }

  set alertDescription(alertDescription: string) {
    this.setAttribute('data-alert-description', alertDescription);
  }

  get sensor(): string {
    return this.getAttribute('data-sensor') || '';
  }

  set sensor(sensor: string) {
    this.setAttribute('data-sensor', sensor);
  }

  get identicalTactic(): number {
    const identicalTactic = this.getAttribute('data-identical-tactic');
    return identicalTactic ? parseInt(identicalTactic, 10) : 0;
  }

  set identicalTactic(identicalTactic: number | null) {
    if (typeof identicalTactic === 'number') {
      this.setAttribute('data-identical-tactic', String(identicalTactic));
    }
  }

  get numberOfEndpoints(): number {
    const numberOfEndpoints = this.getAttribute('data-number-of-endpoints');
    return numberOfEndpoints ? parseInt(numberOfEndpoints, 10) : 0;
  }

  set numberOfEndpoints(numberOfEndpoints: number | null) {
    if (typeof numberOfEndpoints === 'number') {
      this.setAttribute('data-number-of-endpoints', String(numberOfEndpoints));
    }
  }

  get numberOfServers(): number {
    const numberOfServers = this.getAttribute('data-number-of-servers');
    return numberOfServers ? parseInt(numberOfServers, 10) : 0;
  }

  set numberOfServers(numberOfServers: number | null) {
    if (typeof numberOfServers === 'number') {
      this.setAttribute('data-number-of-servers', String(numberOfServers));
    }
  }

  get numberOfInternalEmails(): number {
    const numberOfInternalEmails = this.getAttribute('data-number-of-internal-emails');
    return numberOfInternalEmails ? parseInt(numberOfInternalEmails, 10) : 0;
  }

  set numberOfInternalEmails(numberOfInternalEmails: number | null) {
    if (typeof numberOfInternalEmails === 'number') {
      this.setAttribute('data-number-of-internal-emails', String(numberOfInternalEmails));
    }
  }

  get numberOfIps(): number {
    const numberOfIps = this.getAttribute('data-number-of-ips');
    return numberOfIps ? parseInt(numberOfIps, 10) : 0;
  }

  set numberOfIps(numberOfIps: number | null) {
    if (typeof numberOfIps === 'number') {
      this.setAttribute('data-number-of-ips', String(numberOfIps));
    }
  }

  get numberOfIdentities(): number {
    const numberOfIdentities = this.getAttribute('data-number-of-identities');
    return numberOfIdentities ? parseInt(numberOfIdentities, 10) : 0;
  }

  set numberOfIdentities(numberOfIdentities: number | null) {
    if (typeof numberOfIdentities === 'number') {
      this.setAttribute('data-number-of-identities', String(numberOfIdentities));
    }
  }
}
